import { fabric } from "@utils/fabric";
import { TypeUnderline } from "react-bootstrap-icons";
import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../context/AppContext";

function FontUnderline() {
  const { canvas, selectedObject } = useContext(AppContext);
  const [underline, setUnderline] = useState(
    (selectedObject as fabric.Textbox)?.underline
  );

  // triggered by clicking layers
  useEffect(() => {
    setUnderline((selectedObject as fabric.Textbox)?.underline);
  }, [selectedObject]);

  function onClick() {
    setUnderline(!underline);
    (selectedObject as fabric.Textbox)?.set({ underline: !underline });
    canvas?.renderAll();
  }

  return (
    <button
      className={`flex items-center justify-center h-9 w-9 rounded-lg border transition-all duration-200 ${
        underline 
          ? "bg-blue-500 border-blue-500 text-white shadow-sm" 
          : "bg-white border-gray-300 text-gray-700 hover:bg-gray-50 hover:border-gray-400"
      }`}
      onClick={onClick}
    >
      <TypeUnderline size={16} />
    </button>
  );
}

export default FontUnderline;
